<form #attachTrailerForm="ngForm">
  <sc-title>
    <sc-dictionary-label dictionaryKey="tmc-yard.ui.transport.attach-detach.dialog.step.title.attach-trailer"></sc-dictionary-label>
  </sc-title>
  <sc-content-spacer vertical></sc-content-spacer>
  <sc-string-field name="value" [(ngModel)]="stepperModel.workingData.trailerNumberPlate"
    #ctrlTrailerNumberPlate="ngModel"
    labelDictionaryKey="tmc-yard.entity.transport.masterdata.firstLoadCarrier.trailerNumberPlate"
    [required]="true" grow></sc-string-field>
</form>
